import React from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";

interface DeleteVehicleConfirmDialogProps {
  open: boolean;
  isDeleting?: boolean;
  errorMessage?: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteVehicleConfirmDialog: React.FC<DeleteVehicleConfirmDialogProps> = ({
  open,
  isDeleting,
  errorMessage,
  onConfirm,
  onCancel,
}) => (
  <Dialog open={open} onClose={isDeleting ? undefined : onCancel} maxWidth="xs" fullWidth>
    <DialogTitle>Remove vehicle?</DialogTitle>
    <DialogContent>
      <DialogContentText>This vehicle will be permanently removed from your account.</DialogContentText>
      {errorMessage && (
        <Typography variant="caption" color="error" sx={{ display: "block", mt: 1 }}>
          {errorMessage}
        </Typography>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} disabled={isDeleting}>
        Cancel
      </Button>
      <Button onClick={onConfirm} color="error" variant="contained" disabled={isDeleting}>
        {isDeleting ? <CircularProgress size={18} color="inherit" /> : "Remove"}
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteVehicleConfirmDialog;
